import { moneyFormat, numbFormat } from "./modules/functions";
import { toggleLoader } from "./modules/functions";
import pdfMake from "pdfmake/build/pdfmake";
import pdfParams from "./pdf/params";

// import "./pdf/pdfjs/pdf";
// import "./pdf/pdfjs/pdf.worker";

const { __ } = wp.i18n;

var calcSettings;
var globalCalcMode = "clearence";
var globalShippingTotal = 0;
var globalClearenceTotal = 0;
var globalShipping = {};
var globalClearence = {};

var intersectionObserver = new IntersectionObserver(async (entries) => {
	if (calcSettings) return;
	if (entries[0].intersectionRatio <= 0) return;
	let response = await fetch(theme.api.endpoint + "adream/v1/auctions");
	let result = await response.json();
	calcSettings = result;
});

// начать наблюдение
if (document.getElementById("formCalcShipping")) {
	intersectionObserver.observe(document.getElementById("formCalcShipping"));
}

const changeAuctionsOptions = (event) => {
	const auction = document.getElementById("auction");
	const auctionCity = document.getElementById("auctionCity");
	const costOfTheCar = document.getElementById("costOfTheCar");
	if (!auctionCity || !auction) return;

	if (!calcSettings) {
		setTimeout(changeAuctionsOptions, 1000);
		return;
	}

	auctionCity.innerHTML = "";
	if (auctionCity.tomselect) {
		auctionCity.tomselect.clear();
		auctionCity.tomselect.clearOptions();
	}

	const auctionData = calcSettings.auctions.find(
		(el) => el.name == auction.value
	);

	auctionData.price.forEach((element) => {
		let option = document.createElement("option");
		option.setAttribute("value", element.price);
		option.dataset.port = element.port;
		option.innerHTML = element.city;
		option.value = element.city;
		auctionCity.insertAdjacentElement("beforeend", option);
	});

	if (auctionCity.tomselect) {
		auctionCity.tomselect.sync();
		auctionCity.tomselect.enable();
	}
};

const changeAuctionCity = () => {
	const auctionCity = document.getElementById("auctionCity");
	const portFrom = document.getElementById("portFrom");
	const portTo = document.getElementById("portTo");

	if (!portFrom || !auctionCity || !portTo) return;

	if (!calcSettings) {
		setTimeout(changeAuctionCity, 1000);
		return;
	}

	const portCurrent =
		auctionCity.options[auctionCity.selectedIndex].dataset.port;
	portFrom.value = portCurrent;
	// Array.prototype.forEach.call(portTo.options, (option) => {
	// 	if (!option.value) {
	// 		return;
	// 	}
	// 	const portData = calcSettings.seaShippingPrice.find((el) => el.port == option.value);
	// 	if (portData.port === '0') {
	// 		option.setAttribute('disabled', 'true');
	// 	} else {
	// 		option.removeAttribute('disabled');
	// 	}
	// });

	// portTo.removeAttribute('disabled');
	// portTo.closest('.input').classList.remove('disabled');
	// if (portTo.tomselect) {
	// 	portTo.tomselect.sync();
	// 	portTo.tomselect.enable();
	// }
};

const changeTurnkeyServiceCheckbox = () => {
	const turnkeyService = document.getElementById("turnkeyService");
	turnkeyService.parentNode.classList.toggle("hidden");
	turnkeyService.toggleAttribute("required");
	turnkeyService.value = "";
};

document
	.getElementById("turnkeyServiceCheckbox")
	?.addEventListener("input", changeTurnkeyServiceCheckbox);

document
	.getElementById("auction")
	?.addEventListener("input", changeAuctionsOptions);

document
	.getElementById("auctionCity")
	?.addEventListener("input", changeAuctionCity);

document
	.getElementById("engineType")
	?.addEventListener("input", changeEngineType);

function changeEngineType(event) {
	const selectEngineVolume = document.getElementById("engineVolume");
	const selectEnginePower = document.getElementById("enginePower");
	if (event.target.value == "electric") {
		selectEngineVolume.parentNode.classList.add("hidden");
		selectEnginePower.parentNode.classList.remove("hidden");
		selectEnginePower.setAttribute("required", true);
	} else {
		selectEngineVolume.parentNode.classList.remove("hidden");
		selectEnginePower.parentNode.classList.add("hidden");
		selectEnginePower.removeAttribute("required");
		selectEnginePower.value = "";
	}
}

[
	document.getElementById("engineVolume"),
	document.getElementById("enginePower"),
].forEach((el) => el.addEventListener("input", setEngineParam));

function setEngineParam(event) {
	const selectEngineParam = document.getElementById("engineParam");
	selectEngineParam.value = event.target.value;
}

window.addEventListener("DOMContentLoaded", changeAuctionCity);

document
	.getElementById("formCalcClearence")
	?.addEventListener("submit", sendClearenceCalculationData);

document
	.getElementById("formCalcShipping")
	?.addEventListener("submit", sendShippipngCalculationData);

async function sendClearenceCalculationData(e) {
	e.preventDefault();

	const loadingElement = e.target.querySelector('[type="submit"]');
	const formData = new FormData(e.target);

	formData.append("wpnonce", theme.api.nonce);
	formData.set("costOfTheCar", moneyFormat.from(formData.get("costOfTheCar")));
	formData.delete("engineVolume");
	formData.delete("enginePower");

	let dataForForm = formData;

	if (document.getElementById("formCalcShipping")) {
		const formShippingData = new FormData(
			document.getElementById("formCalcShipping")
		);

		formShippingData.set(
			"costOfTheCar",
			moneyFormat.from(formShippingData.get("costOfTheCar"))
		);

		if (formShippingData.get("turnkeyService")) {
			formShippingData.set(
				"turnkeyService",
				moneyFormat.from(formShippingData.get("turnkeyService"))
			);
		} else {
			formShippingData.set("turnkeyService", 0);
		}

		const auctionCity = document.getElementById("auctionCity");

		if (auctionCity) {
			formShippingData.set(
				"auctionCity",
				auctionCity.options[auctionCity.selectedIndex].text
			);
		}

		formShippingData.delete("isTurnkeyService");
		formShippingData.delete("isInsurance");
		formShippingData.delete("isRepair");
		formData.delete("costOfTheCar");

		const mergedFormData = new FormData();

		// Додавання даних з першого об'єкта FormData
		for (const [key, value] of formData.entries()) {
			mergedFormData.append(key, value);
		}

		// Додавання даних з другого об'єкта FormData
		for (const [key, value] of formShippingData.entries()) {
			mergedFormData.append(key, value);
		}
		mergedFormData.set("calcMode", "all");

		dataForForm = mergedFormData;
	}

	const data = new URLSearchParams(dataForForm);
	const headers = new Headers();
	headers.append("Content-Type", "application/x-www-form-urlencoded");

	toggleLoader(loadingElement);
	toggleLoader(e.target);

	let response = await fetch(theme.api.endpoint + "adream/v1/calc?" + data, {
		method: "GET",
		headers: headers,
	});

	let result = await response.json();

	if (result) {
		if (document.getElementById("formCalcShipping")) {
			globalShippingTotal =
				result.payments_by.shipp_and_clearence.shipping.value;
			globalShipping = result.payments_by.shipp_and_clearence.shipping;
			printResults(result, "shipping");
		}
		globalClearenceTotal =
			result.payments_by.shipp_and_clearence.clearence.value;
		globalClearence = result.payments_by.shipp_and_clearence.clearence;
		printResults(result, "clearence");

		const event = new CustomEvent("calucalated_clearence");
		document.dispatchEvent(event);
	} else {
		console.log("НЕ Пішло");
	}
	toggleLoader(loadingElement);
	toggleLoader(e.target);
}

async function sendShippipngCalculationData(e) {
	e.preventDefault();

	const loadingElement = e.target.querySelector('[type="submit"]');
	const formData = new FormData(e.target);
	formData.append("wpnonce", theme.api.nonce);
	formData.set("costOfTheCar", moneyFormat.from(formData.get("costOfTheCar")));

	if (formData.get("turnkeyService")) {
		formData.set(
			"turnkeyService",
			moneyFormat.from(formData.get("turnkeyService"))
		);
	} else {
		formData.set("turnkeyService", 0);
	}

	const auctionCity = document.getElementById("auctionCity");
	if (auctionCity) {
		formData.set(
			"auctionCity",
			auctionCity.options[auctionCity.selectedIndex].text
		);
	}

	// formData.delete("engineVolume");
	// formData.delete("enginePower");
	formData.delete("isTurnkeyService");
	formData.delete("isInsurance");
	formData.delete("isRepair");

	const data = new URLSearchParams(formData);
	const headers = new Headers();
	headers.append("Content-Type", "application/x-www-form-urlencoded");

	toggleLoader(loadingElement);
	toggleLoader(e.target);
	let response = await fetch(theme.api.endpoint + "adream/v1/calc?" + data, {
		method: "GET",
		headers: headers,
		// body: data,
	});
	let result = await response.json();

	// let response = await fetch(theme.api.ajax_url + "?action=add_calculation", {
	// 	method: "POST",
	// 	headers: headers,
	// 	body: data,
	// });

	// let result = await response.json();

	if (result) {
		// console.log(result.data);
		globalCalcMode = "shipping";
		globalShippingTotal = result.payments_by.shipp_and_clearence.shipping.value;
		globalShipping = result.payments_by.shipp_and_clearence.shipping;

		printResults(result, "shipping");

		const customAutoValueElement = document.getElementById("customAutoValue");
		if (customAutoValueElement) {
			customAutoValueElement.value = moneyFormat.to(
				result.args.customAutoValue
			);
		}

		const event = new CustomEvent("calucalated_shipping");
		document.dispatchEvent(event);

		// window.location.href = result.data;
		console.log("Пішло");
	} else {
		console.log("НЕ Пішло");
	}
	toggleLoader(loadingElement);
	toggleLoader(e.target);
}

function printResults(data, type) {
	const payments = data.payments_by.shipp_and_clearence[type];
	const calculationsSection = document.getElementById(`${type}Calculations`);

	calculationsSection.innerHTML = "";

	payments.subpayments.forEach((el, indexTable) => {
		if (el.value == 0) {
			return false;
		}
		// створюємо HTML-рядки таблиці для кожного елемента в об'єкті
		let rows = "";
		let index = 1;
		for (const id in el.subpayments) {
			rows += `
				<tr>
					<td class="pl-40 br-1-grey">${index}</td>
					<td class="br-1-grey">${el.subpayments[id].name}</td>
					<td id="${id}">${moneyFormat.to(el.subpayments[id].value)}</td>
				</tr>
			`;
			index++;
		}

		calculationsSection.insertAdjacentHTML(
			"beforeend",
			`
				<div class="calc-table calc-table-${indexTable}">
					<table>
						<thead>
							<tr>
								<th colspan="3" class="w-full h3">${
									globalCalcMode == "clearence"
										? el.subname
										: el.name + ". " + el.subname
								}</th>
							</tr>
						</thead>
						<tbody>
							${rows}
							<tr>
								<td class="!text-base" colspan="2"><b>Разом</b></td>
								<td class="!text-base">${moneyFormat.to(el.value)}</td>
							</tr>
						</tbody>
					</table>
				</div>
			`
		);
	});

	let noticesHTML = "";

	if (data.notices.length) {
		noticesHTML += '<ul class="calc__notices">';
		data.notices?.forEach((el) => {
			noticesHTML += `<li>${el}</li>`;
		});
		noticesHTML += "</ul>";
	}
	if (globalCalcMode == "shipping") {
		calculationsSection.insertAdjacentHTML(
			"beforeend",
			`
				<div class="calc-table calc-table-total">
					<div class="h3">
						${
							__("Разом", "frontenda-store-front") + " " + payments.name
						}: <span>${moneyFormat.to(payments.value)}</span>
					</div>
					<div class="calc-notice">${noticesHTML}</div>
				</div>
			`
		);
	}
	if (type == "clearence") {
		calculationsSection.insertAdjacentHTML(
			"beforeend",
			`
				<div class="calc-table calc-table-total">
					<div class="h1">
						${__("Всього", "frontenda-store-front")}: <span>${moneyFormat.to(
				globalShippingTotal + globalClearenceTotal
			)}</span>
					</div>
				</div>
			`
		);

		data.shipping = globalShipping;
		data.clearence = globalClearence;

		const event = new CustomEvent("calucalated", {
			detail: { data: data },
		});
		document.dispatchEvent(event);
	}
}
document.addEventListener("calucalated_shipping", (e) => {
	document.getElementById("shippingCalculations").classList.remove("hidden");
	document.getElementById("sectionCalcClearence").classList.remove("hidden");
	document.getElementById("shippingCalculations").scrollIntoView();
});

document.addEventListener("calucalated_clearence", (e) => {
	document.getElementById("clearenceCalculations").classList.remove("hidden");
	document.getElementById("clearenceCalculations").scrollIntoView();
});

document.addEventListener("calucalated", (e) => {
	const data = e.detail.data;
	var fonts = {
		Roboto: {
			normal:
				"https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.3.0-beta.1/fonts/Roboto/Roboto-Regular.ttf",
			bold: "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.3.0-beta.1/fonts/Roboto/Roboto-Medium.ttf",
		},
	};
	// return;
	pdfMake.addFonts(fonts);
	pdfMake
		.createPdf(pdfParams(data))
		// .download()
		.getDataUrl()
		.then(async (dataUrl) => {
			const targetElement = document.getElementById("iframeContainer");
			targetElement.parentElement.parentElement.classList.remove("hidden");
			const iframe = document.createElement("iframe");
			iframe.src = dataUrl;
			targetElement.innerHTML = "";
			targetElement.appendChild(iframe);

			const PDFJS = await import("pdfjs-dist/build/pdf");
			const pdfjsWorker = await import("pdfjs-dist/build/pdf.worker.entry");

			PDFJS.GlobalWorkerOptions.workerSrc = pdfjsWorker;

			// Load PDF file
			PDFJS.getDocument(dataUrl).promise.then(function (pdf) {
				// Get the first page
				pdf.getPage(1).then(function (page) {
					// Set the canvas element to the same size as the PDF page
					const canvas = document.getElementById("pdf-canvas");
					const viewport = page.getViewport({ scale: 2 });
					canvas.height = viewport.height;
					canvas.width = viewport.width;

					// Render the PDF page into the canvas
					const renderTask = page.render({
						canvasContext: canvas.getContext("2d"),
						viewport: viewport,
					});

					renderTask.promise.then(function () {
						const link = document.getElementById("btnDownloadCalculations");
						link.addEventListener("click", () => {
							link.href = canvas.toDataURL("image/jpg", 1.0);
							link.download = "adream-" + data.total + "$" + ".jpg";
						});
						// link.click();
					});
				});
			});
		});
});
